import { Action } from '@ngrx/store';

import { MsalService, // BroadcastService
} from '@azure/msal-angular';

export const AuthActionType = {
  AuthConfig: '[Auth] AuthConfig',
  AuthLogin: '[Auth] AuthLogin',
  AuthLogout: '[Auth] AuthLogout',
  AuthLoginFailure: '[Auth] AuthLoginFailure',
  AuthLoginSuccess: '[Auth] AuthLoginSuccess',
};

export interface AuthConfigPayload {
  authService: MsalService;
  // broadcastService: BroadcastService;
}

export class AuthConfig implements Action {
  readonly type = AuthActionType.AuthConfig;
  constructor(public payload: AuthConfigPayload) { }
}

export class AuthLogin implements Action {
  readonly type = AuthActionType.AuthLogin;
  constructor() { }
}

export class AuthLogout implements Action {
  readonly type = AuthActionType.AuthLogout;
  constructor() { }
}

export class AuthLoginFailure implements Action {
  readonly type = AuthActionType.AuthLoginFailure;
  constructor(public payload: any) { }
}

export class AuthLoginSuccess implements Action {
  readonly type = AuthActionType.AuthLoginSuccess;
  constructor(public payload: {
    _token: string,
    _tokenType: string
  }) { }
}


export type AuthAction = AuthConfig
  | AuthLogin
  | AuthLogout
  | AuthLoginFailure
  | AuthLoginSuccess
  ;
